import React from 'react';
import { Smartphone, Cloud, Wifi, Gauge } from 'lucide-react';

const Technology = () => {
  const features = [
    {
      icon: Smartphone,
      title: 'Control móvil',
      description: 'Gestiona tus toldos desde cualquier lugar con nuestra app'
    },
    {
      icon: Cloud,
      title: 'Integración cloud',
      description: 'Compatible con Alexa, Google Home y Somfy TaHoma'
    },
    {
      icon: Wifi,
      title: 'Conectividad IoT',
      description: 'Sistema inteligente conectado a tu hogar'
    },
    {
      icon: Gauge,
      title: 'Sensores inteligentes',
      description: 'Respuesta automática a sol, viento y temperatura'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-br from-[#0A192F] via-[#0A192F] to-[#1a2f4a] relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#FFD700]/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#FFD700]/5 rounded-full blur-3xl"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#F2F2F2] mb-4">
            Confort y control total con{' '}
            <span className="text-[#FFD700]">sistemas inteligentes</span>
          </h2>
          <p className="text-lg text-[#F2F2F2]/80 max-w-3xl mx-auto leading-relaxed">
            Integramos sensores solares, control por voz y apps móviles que permiten gestionar tus toldos y pérgolas desde cualquier lugar. Compatibles con Alexa, Google Home y Somfy TaHoma.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div
                key={index}
                className="bg-[#F2F2F2]/5 backdrop-blur-sm p-8 rounded-xl border border-[#FFD700]/20 hover:border-[#FFD700]/40 transition-all hover:transform hover:scale-105"
              >
                <div className="w-16 h-16 bg-[#FFD700]/20 rounded-full flex items-center justify-center mb-6">
                  <Icon className="w-8 h-8 text-[#FFD700]" />
                </div>
                <h3 className="text-xl font-bold text-[#F2F2F2] mb-3">{feature.title}</h3>
                <p className="text-[#F2F2F2]/70 leading-relaxed">{feature.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Technology;